import {
  Icon,
  List,
  Paragraph,
  Spacer,
  Spreader,
  Tooltip
} from '@landingi/landingi-ui-kit'
import {
  getPlansLimits,
  PlansLimitsKeys
} from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/plansLimits'
import styles from '@pages/Pricing/routes/AccountPackage/components/PlanPanels/components/SummarySubscriptionModal/SummarySubscriptionModal.module.scss'
import { Trans, useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

export const PlansLimits = ({
  planRecordKey
}: {
  planRecordKey: PlansLimitsKeys
}) => {
  const plansLimits = getPlansLimits('change.plan.page.visits.no.bold')

  const { t } = useTranslation()

  const visitsLimits = plansLimits[planRecordKey].visits
  const domainsLimits = plansLimits[planRecordKey].domains
  const landingPagesLimits = plansLimits[planRecordKey].landing_pages

  return (
    <div className={styles['summary-subscription-modal__row']}>
      <div className={styles['summary-subscription-modal__icon']}>
        <Icon icon='icon-modal-envelope-outline' size={14} />
      </div>

      <div>
        <Paragraph weight={400} line={20} size={16} padding='none'>
          <Tooltip content={t('change.plan.page.plans.limit.tooltip')}>
            <Trans i18nKey='change.plan.page.plans.limit' />

            <Spreader spread='mini' />

            <Icon icon='icon-help_outline' />
          </Tooltip>
        </Paragraph>
      </div>

      <div>
        <List>
          <Row>
            <Icon
              icon='icon-ok'
              className={styles['summary-subscription-modal__icon']}
              color='color-3'
            />

            <Spreader spread='mini' />

            <Paragraph weight={400} line={20} size={16} padding='none'>
              {visitsLimits}
            </Paragraph>
          </Row>

          <Spacer space='tiny' />

          <Row>
            <Icon
              icon='icon-ok'
              className={styles['summary-subscription-modal__icon']}
              color='color-3'
            />
            <Spreader spread='mini' />
            <Paragraph weight={400} line={20} size={16} padding='none'>
              {domainsLimits}
            </Paragraph>
          </Row>

          <Spacer space='tiny' />

          <Row>
            <Icon
              icon='icon-ok'
              className={styles['summary-subscription-modal__icon']}
              color='color-3'
            />
            <Spreader spread='mini' />
            <Paragraph weight={400} line={20} size={16} padding='none'>
              {landingPagesLimits}
            </Paragraph>
          </Row>
        </List>
      </div>
    </div>
  )
}
